export const BATCH_STATUS_VALID = 1;
export const BATCH_STATUS_WARNING = 2;
export const BATCH_STATUS_INVALID = 3;
